var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('LazyLoad',[_c('MapComponent',_vm._b({attrs:{"center":_vm.center}},'MapComponent',_vm.$attrs,false))],1),(_vm.value && _vm.value.formatted)?_c('div',{staticClass:"map__address"},[_vm._v(" "+_vm._s(_vm.value.formatted)+" ")]):_vm._e(),_c('div',{staticClass:"scroll-anchor",attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }